<template>
  <div class="app-container paper-list">
    <basic-container class = "paper-list-container">
      <avue-crud
        ref="crud"
        :option="tableOption"
        :data="tableData"
        :page="page"
        :table-loading="tableLoading"
        :before-open="handleOpenBefore"
        @refresh-change="getList"
        @current-change="handleCurrentChange"
        @selection-change="selectionChange"
        @size-change="handleSizeChange"
        @current-row-change="handRowClick">
        <template slot="menuLeft">
          <div class="paper-list-filter">
            <div class="grid-content bg-purple">
              <el-row>
                <div v-if="isSubjectLib">
                  <el-col>
                    <el-input class="paper-list-filter-value" v-model.trim="search.name" 
                      @keyup.enter.native="searchChange" placeholder="题库名称" clearable size="small" suffix-icon="el-icon-search"></el-input>
                  </el-col>
                </div>
                <div v-else>
                  <el-col :span="12">
                    <el-input class="subject-lib-list-filter-value" v-model.trim="search.content" 
                      @keyup.enter.native="searchChange" placeholder="题目" clearable size="small" suffix-icon="el-icon-search"></el-input>
                  </el-col>
                  <el-col :span="12">
                    <el-select class="subject-lib-list-filter-value" placeholder="类型" v-model="search.type" clearable size="small">
                      <el-option
                        v-for="item in subjectTypeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                </div>
              </el-row>
            </div>
          </div>
        </template>
        <template slot="menuRight">
          <div>
            <el-button type="primary" icon="el-icon-search" circle size="small" @click="searchChange"></el-button>
            <el-button icon="el-icon-delete" circle size="small" @click="searchReset"></el-button>
          </div>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import { getSubjectList } from '@/api/app/subject'
import { getSubjectLibList } from '@/api/app/subject-lib'
import { subjectTypeList } from '@/const/crud/app/subject-lib'
import { mapGetters } from 'vuex'

export default {
  name: 'subjectDialog',
  props: {
    tableOption: {
      type: Array,
    },
    libId: {
      type: Number,
      default: 0
    },
    isSubjectLib: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      search: {
        current: 1,
        size: 10,
        name: '',
        content: '',
        type: '',
      },
      subjectTypeList,
      // 列表页面
      tableData:[],
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示多少条,
      },
      tableLoading: false,
      selectSubjectList: [],
    }
  },
  watch: {
    libId: {
      handler() {
        this.getList();
      },
      immediate: true,
    },
  },
  created() {
    this.getList()
  },
  computed: {
    ...mapGetters(['permissions']),
  },
  activated() {
    this.getList();
  },
  methods: {
    getList() {
      let params = {
        current: this.search.current,
        size: this.search.size
      }
      this.tableLoading = true
      if (this.isSubjectLib) {
        if (this.search.name != "" && this.search.name.trim() != "") {
          params.name = this.search.name
        }
        getSubjectLibList(params).then(response => {
          this.tableData = response.data.data.records;
          this.page.total = response.data.data.total
          this.tableLoading = false
        }).catch(error => {
          console.error(error)
          this.$message({
            message: '获取题库列表失败',
            type: 'error'
          })
          this.tableLoading = false;
        })
      } else {
        if (this.libId) {
          params.libId = this.libId;
          if (this.search.content != "" && this.search.content.trim() != "") {
            params.content = this.search.content
          }
          if (this.search.type != "") {
            params.type = this.search.type
          }
          getSubjectList(params).then(response => {
            this.tableData = response.data.data.records;
            this.tableData.forEach(record => {
              record.type = (subjectTypeList.find((v) => (v.value == record.type)) ? subjectTypeList.find((v) => (v.value == record.type)).label :'类型异常');
            })
            this.page.total = response.data.data.total
            this.tableLoading = false
          }).catch(error => {
            console.error(error)
            this.$message({
              message: '获取题目列表失败',
              type: 'error'
            })
            this.tableLoading = false;
          })
        } else {
          this.tableLoading = false;
        }
      }
    },
    handleCurrentChange(val) {
      this.page.currentPage = val
      this.search.current = val
      this.getList()
    },
    handleSizeChange(val) {
      this.page.pageSize = val
      this.search.size = val
      this.getList()
    },
    initPage() {
      this.page.currentPage = 1
      this.page.pageSize = this.search.size
      this.search.current = 1
    },
    searchChange() {
      this.initPage()
      this.getList()
    },
    searchReset() {
      this.search.title = '',
      this.search.creator = '',
      this.search.type = '',
      this.searchChange()
    },
    handRowClick(row, event, column) {
      this.$emit('handClickSubjectLib', row.id);
    },
    selectionChange(row) {
      this.selectSubjectList = []
      row.forEach(item => {
        this.selectSubjectList.push(item);
      })
    },
  },
}
</script>

<style lang="scss" scoped>

.paper-list {
  &-filter {

    &-value {
      width: 96%!important;
    }

    &-date {
      width: 96%!important;
    }

    &-reset {
      float: right;
      margin-right: 8px;
    }

    &-search {
      float: right;
      margin-right: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }

  &-container {
    padding-top: 0px;
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 170px;
      text-align: left;
    }
  }
}
</style>
